"use strict";
import $ from 'jquery';
import _ from 'lodash';
import {PhoneNumberUtil} from 'google-libphonenumber';
import Config from './config';

const phoneUtil = PhoneNumberUtil.getInstance();

let _qqGirlHidden = false;

module.exports = {
  layerBgUrl: function (imageUrl) {
    imageUrl = encodeURI(imageUrl).replace(new RegExp('#', 'g'), '%23');
    return this.bgImageUrl(Config.AmazonS3.root + imageUrl + '_' + Config.layerSize() + '.png');
  },
  imgSrc: function (imageUrl) {
    return Config.AmazonS3.root + imageUrl + '_' + Config.layerSize() + '.png';
  },
  bgImageUrl: function (imageUrl) {
    return "url('" + imageUrl + "')";
  },
  splitFilter: function (filter) {
    const res = {};
    _.forEach(filter.split('&'), function (pair) {
      const ar = pair.split('=');
      res[ar[0]] = ar[1];
    });
    return res;
  },

  localImage: function (image) {
    return ((Config.kioskStandAlone || location.port == 9007) ? './images/' : '/content/Views/QuickQuote-v3/images/') + image;
  },

  /**
   * Makes a case-insensitive string compare
   * @param s1 {string}
   * @param s2 {string}
   * @returns {boolean}
   */
  iCmp: function (s1, s2) {
    if (!s1 && !s2) {
      return true;
    }
    if (!s1 || !s2) {
      return false;
    }

    return s1.toUpperCase() === s2.toUpperCase();
  },
  keysAndProps: function (obj) {
    const res = _.keys(obj);
    for (let key in res) {
      const prop = obj[key];
      if (Array.isArray(prop)) {
        res.push(prop);
      }
    }

    return res;
  },
  isObject: function (val) {
    if (val === null) {
      return false;
    }
    return ((typeof val === 'function') || (typeof val === 'object'));
  },

  /**
   * return the path without last part which is supposelly the file name
   * @param {string} path
   * @param {int} [count=1]
   */
  pathPrefix: function (path, count) {
    count = count || 1;
    while (count-- > 0) {
      const index = path.lastIndexOf("/");
      if (index === -1) {
        return path;
      }

      path = path.substr(0, index);
    }

    return path;
  },

  /**
   * Converts a string to a boolean value
   * @param value
   */
  toBoolean: function (value) {
    if (typeof (value) === 'string') {
      value = value.toLowerCase();
    }
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  },

  convertKeysToCamelCase: function (obj) {
    if (!obj || typeof obj !== "object") {
      return null;
    }

    if (obj instanceof Array) {
      return $.map(obj, function (value) {
        return this.convertKeysToCamelCase(value);
      });
    }

    let newObj = {};
    $.each(obj, function (key, value) {
      key = key.charAt(0).toLowerCase() + key.slice(1);
      newObj[key] = value;
    });

    return newObj;
  },
  toCamel: function (o) {
    let build, key, destKey, value;

    if (o instanceof Array) {
      build = [];
      for (key in o) {
        value = o[key];

        if (typeof value === "object") {
          value = this.toCamel(value);
        }
        build.push(value);
      }
    } else {
      build = {};
      for (key in o) {
        if (o.hasOwnProperty(key)) {
          destKey = (key.charAt(0).toLowerCase() + key.slice(1) || key).toString();
          value = o[key];
          if (value !== null && typeof value === "object") {
            value = this.toCamel(value);
          }

          build[destKey] = value;
        }
      }
    }
    return build;
  },
  ignoreDefault: function (e) {
    e.preventDefault();
    e.stopPropagation();
  },

  ignore: function (e, cb) {
    this.ignoreDefault(e);
    cb();
  },

  toCamelCase: function (s) {
    return s.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  toColor: function (num) {
    num >>>= 0;
    const b = num & 0xFF,
      g = (num & 0xFF00) >>> 8,
      r = (num & 0xFF0000) >>> 16,
      a = ((num & 0xFF000000) >>> 24) / 255;
    return "rgba(" + [r, g, b, a].join(",") + ")";
  },
  formatPhone: function (phone) {
    if (!phone) {
      return '';
    }

    return phone.replace(/[\(|\)]/g, '').replace(/[\s\-]/g, '.');
  },
  getClickPosition: function (el) {
    let xPosition = 0;
    let yPosition = 0;

    while (el) {
      if (el.tagName === "BODY") {
        // deal with browser quirks with body/window/document and page scroll
        const xScrollPos = el.scrollLeft || document.documentElement.scrollLeft;
        const yScrollPos = el.scrollTop || document.documentElement.scrollTop;

        xPosition += (el.offsetLeft - xScrollPos + el.clientLeft);
        yPosition += (el.offsetTop - yScrollPos + el.clientTop);
      } else {
        xPosition += (el.offsetLeft - el.scrollLeft + el.clientLeft);
        yPosition += (el.offsetTop - el.scrollTop + el.clientTop);
      }

      el = el.offsetParent;
    }
    return {
      x: xPosition,
      y: yPosition
    };
  },

  hideQQGirl: function () {
    if (document.kvConfig.kioskMode && !_qqGirlHidden && Config.parent.$) {
      _qqGirlHidden = true;
      Config.parent.$(Config.parent.document).trigger('hide-qq-girl');
    }
  },
  playVideo: function (id, callback) {
    ///TODO: When Girl videos are updated remove "|| true"
    if (!document.kvConfig.kioskMode || true) {
      return;
    }
    const $guide = $(id);
    if (!$guide.length) {
      return;
    }
    const guide = $guide[0];
    $guide.off('canplaythrough').on('canplaythrough', function () {
      $guide.show();
      guide.play();
      if (callback) {
        setTimeout(callback, 50);
      }
    });
    guide.load();
  },

  hideVideo: function (id) {
    const $guide = $(id);
    if (!$guide.length) {
      return false;
    }

    const guide = $guide[0];
    $guide.hide();
    guide.pause();
    return true;
  },

  getIntroVideo: function (view) {
    const path = Config.kioskStandAlone ? "./../../videos/video_guide/" : 'https://s3.amazonaws.com/intro-videos/';
    switch (view) {
      case 'customerPopup':
        return path + 'Customer-Popup-25M.webm';
      case 'projectScope':
        return path + 'Instant-Quote-Intro-25M.webm';
      case 'reviewSubmit':
        return path + 'Review-Submit-25M.webm';
      case 'lockedStone':
        return path + 'Stone-Select-Locked-25M.webm';
      case 'sqftCalc':
        return path + 'SQFT-Calculator-25M.webm';
    }
  },
  formatCurrency: function (currencyNumber) {
    let currencyString = currencyNumber.toFixed(2);
    let cents = currencyString.split(".")[1];
    let dollars = currencyString.split(".")[0];
    // start at the end and every 3 numbers add a comma to the string
    for (let i = dollars.length - 3; i > 0; i = i - 3) {
      dollars = dollars.slice(0, i) + "," + dollars.slice(i);
    }
    return "$" + dollars + "." + cents;
  },
  extractDomain: function (url) {
    let domain;
    let protocol = null;
    let subDomain = null;
    //find & remove protocol (http, ftp, etc.) and get domain
    if (url.indexOf("://") > -1) {
      const ar = url.split('/');

      domain = ar[2];
      protocol = ar[0].slice(0, -1);
    }
    else {
      domain = url.split('/')[0];
    }

    //find & remove port number
    domain = domain.split(':')[0];

    const domainParts = domain.split('.');
    if (domainParts.length === 3) {
      subDomain = domainParts[0];
    }

    return {domain, protocol, subDomain};
  },
  monads: {
    ifNotNull: function (o, notNullCallback) {
      if (o) {
        return notNullCallback(o);
      }

      return null;
    }
  },
  isEmail: function (email) {
    if (!email || email.indexOf('@') === -1) {
      return false;
    }

    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    return re.test(email);
  },

  isZip: function (zip) {
    return zip && (/^\d{5}$/.test(zip) ||
      /^[\d\w]{6}$/i.test(zip) ||
      /^\d{5}(-\d{4})*$/i.test(zip));
  },
  isPhoneNumber: function (phone) {
    if(Config.kioskStandAlone) {
      return /^\+?\d{10,16}$/.test(phone.replace(/[^0-9]/g, ''));
    }
    if(phone.indexOf('555-555-5555') >= 0)
      return true;
    try {
      return phone && phoneUtil.isValidNumber(phoneUtil.parse(phone)); // /^\+?\d{10,16}$/.test(phone);
    } catch(ex) {
      return false;
    }
  },
  isMobile: (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
};




// WEBPACK FOOTER //
// ./src/misc.js